<template>
    <div id="removeclass">
      <app-modal
        :modal-id="modalId"
        :modal-alignment="modal_alignment"
        modal-size="large"
        @close-modal="closeModal"
        style="background:rgba(0, 0, 0, .5)"
      >
        <template slot="header">
          <h4>{{modalTitle}}</h4>
        </template>
        <app-overlay-loader v-if="preloader" />
        <template slot="body">
            <table class="table">
              <thead class="thead-dark">
                <tr>
                  <th>User Name</th>
                  <th>Signature</th>
                </tr>
              </thead>
              <tbody v-if="list.length > 0">
                <tr v-for="(user,index) in list" :key="index">
                  <td width="60%">
                    <h5 class="mb-1 mt-3" style="font-size: 1.15rem">
                      {{ user.task_users != null ? user.task_users.full_name : '' }}
                    </h5>
                    <p class="mb-2 text-muted font-size-90">{{ user.task_users != null ? user.task_users.email : '' }}</p>
                    <p class="text-muted font-size-90">Endorse Date: {{ user.get_endorsement ? getDateTimeFormatForBackend(user.get_endorsement.created_at) : '' }} </p>
                    <span v-if="user.get_endorsement != null " :class="'badge badge-sm badge-pill badge-success'">Endorsed</span>
                    <span v-else :class="'badge badge-sm badge-pill badge-warning'">Pending</span>
                  </td>
                  <td width="40%">
                    <app-avatar v-if="user.get_endorsement == null" :title="user.task_users != null ? user.task_users.full_name : ''" avatar-class="avatars-w-50 text-center"
                                    :alt-text="$t('not_found')"/>
                    <div class="text-center">
                      <img v-if="user.get_endorsement != null" :src="user.get_endorsement.signature" :alt="$t('not_found')" class="img-fluid img-thumbnail">
                    </div>
                  </td>
                </tr>
              </tbody>
              
            </table>      
        </template>
        <template slot="footer">
          <button  @click.prevent="close()" class="btn btn-primary mr-2" >Close</button>
        </template>
      </app-modal>
    </div>
  </template>
  <script>
  import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
  import { ModalMixin } from "../../../../../Mixins/ModalMixin";
  import * as actions from "../../../../../Config/ApiUrl";
  import { axiosPost, axiosGet } from "../../../../../Helpers/AxiosHelper.js";
  import AppLibrary from "../../../../../Helpers/AppLibrary";
  
  export default {
    name: "AddModal",
    extends: AppLibrary,
    mixins: [FormMixin, ModalMixin],
    props: {
      task_id: Number,
      form_revision_id: Number,
    },
    data() {
      return {
        list: [],
        modal_alignment: 'top',
        preloader: false,
        modalId: "view-signature-modal",
        modalTitle: 'Form Endorsement',
      };
    },
    created() {
        this.getEndorsement();
    },
    methods: {
        close() {
            $("#"+ this.modalId).modal("hide");
        },
        getEndorsement() {
          let task_id = this.task_id;
          let form_revision_id = this.form_revision_id;
          axiosGet(actions.FORM_ENDORSEMENT_PROGRESS +'/'+ task_id+'?form_revision_id='+form_revision_id)
              .then((res) => {
                this.list = res.data.list;
              })
              .catch((error) => {
                console.error(error);
              });
        },
    },
  };
  </script>